import { render, staticRenderFns } from "./BrandsTabList.vue?vue&type=template&id=4d98d95c"
import script from "./BrandsTabList.vue?vue&type=script&lang=js"
export * from "./BrandsTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports